import { createAppAsyncThunk } from "Store/createAppAsyncThunk";

import { selectCarbonEmissionsStateByOrganizationId } from "../carbonEmissions.selectors";

import { fetchPreviousYearMonthlyCarbonEmissionsThunk } from "./fetchOrganizationCarbonEmissions.thunk";

export const ensureOrganizationCarbonEmissionsLoaded = createAppAsyncThunk(
  "carbonEmissions/ensureOrganizationCarbonEmissionsLoaded",
  async (organizationId: string, { dispatch, getState }) => {
    const state = getState();
    const orgState = selectCarbonEmissionsStateByOrganizationId(state, {
      organizationId
    });

    // Don't load if already loading
    if (orgState.isLoading) {
      return { skipped: true, reason: "already_loading" };
    }

    // Don't retry if we have a non-retryable error
    if (orgState.isNonRetryableError) {
      return { skipped: true, reason: "non_retryable_error" };
    }

    // Don't load if we already have valid data
    if (orgState.data && hasValidData(orgState.data)) {
      return { skipped: true, reason: "already_loaded" };
    }

    // Load the data
    const result = await dispatch(
      fetchPreviousYearMonthlyCarbonEmissionsThunk(organizationId)
    );

    return { loaded: true, result };
  }
);

const hasValidData = (data: any): boolean => {
  return (
    data && data.data && data.data.projects && Array.isArray(data.data.projects)
  );
};
